import { css } from '@emotion/core';
export var IconSize;
(function (IconSize) {
  IconSize["regular"] = "24px";
  IconSize["small"] = "18px";
})(IconSize || (IconSize = {}));
var iconSize = size => /*#__PURE__*/css("width:", IconSize[size], ";height:", IconSize[size], ";");
export var domainIcon = size => /*#__PURE__*/css("stroke-linejoin:round;stroke-linecap:round;fill:none;vertical-align:middle;use{pointer-events:none;}", size && iconSize(size), ";");